module.exports = __webpack_public_path__ + "static/media/respiratory.5897bc81.jpeg";